export const playButton = (size = 60) => `<div class="play_button_overlay uk-position-center" style="width: ${size}px !important; height: ${size}px;">
    <svg class="uk-position-center" xmlns="http://www.w3.org/2000/svg" width="${size * 0.7}" height="${size * 0.7}" viewBox="0 0 48 48">
            <path d="M16 10v28l22-14z"></path>
    </svg>
</div>`;
